export default "<div fxLayoutAlign=\"start center\" fxLayout class=\"ml10 caption\">\r\n  <span>{{ control.caption }}</span>\r\n</div>\r\n";